import React from 'react';
import FeatureFlagsPage from '../features/featureFlags/pages/FeatureFlagsPage';

const FeatureFlags: React.FC = () => <FeatureFlagsPage />;

export default FeatureFlags;
